module.exports = __webpack_public_path__ + "static/assets/scifu-fc.f2eef973.svg";